import React from "react";
import { useUser } from "../context/UserContext";

export default function Profile() {
  const { user } = useUser();

  return (
    <div className="min-h-screen p-8 bg-gray-50">
      <div className="max-w-3xl mx-auto">
        <h1 className="text-2xl font-bold mb-4">Perfil</h1>
        <div className="bg-white p-6 rounded-lg shadow">
          <p><strong>Nombre:</strong> {user?.name || '-'}</p>
          <p><strong>Documento / Celular:</strong> {user?.identifier || '-'}</p>
          <pre className="mt-4 text-xs bg-gray-100 p-2 rounded">{JSON.stringify(user, null, 2)}</pre>
        </div>
      </div>
    </div>
  );
}
